import { CSSObject } from '@emotion/react'
import styled from '@emotion/styled'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'
import { WebLink } from '@news-mono/web-common'
import { colors } from '../../../../../../design-tokens/src/thenightly/colors'
import { textMixin } from '../../../../mixins/TextMixin/TextMixin'
import { TheNightlyTheme } from '../../../../__styling'

export const StyledBylineWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 'auto',
}))

const getHeadingStyle = (theme: TheNightlyTheme) => [
    {
        color: colors.palette.section.opinion.default,
        fontWeight: 500,
        textTransform: 'capitalize',
    } as CSSObject,
    textMixin(theme, 'byline-primary-large'),
]

export const StyledBylineHeading = styled('div')(({ theme }) =>
    getHeadingStyle(theme as TheNightlyTheme),
)

export const StyledBylineHeadingLink = styled(WebLink)(({ theme }) => [
    getHeadingStyle(theme as TheNightlyTheme),
    {
        textDecoration: 'none',

        '&:hover, &:focus': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
])

export const StyledBylineSubHeading = styled('div')(({ theme }) => [
    {
        display: 'flex',
        color: colors.palette.neutral[100],
    },
    textMixin(theme as TheNightlyTheme, 'byline-secondary'),
])

export const StyledBylineFooter = styled('div')(({ theme }) => [
    {
        display: 'flex',
        alignItems: 'center',
        gap: calcRem(8),

        color: colors.palette.neutral[60],
        textTransform: 'uppercase',
    },
    textMixin(theme as TheNightlyTheme, 'byline-secondary'),
])

export const StyledBylineBiography = styled.div(({ theme }) => [
    {
        color: colors.palette.neutral[60],
    },
    textMixin(theme as TheNightlyTheme, 'body-alt'),
])
